var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.5C3.1423 0.5 0 3.6423 0 7.5C0 11.3577 3.1423 14.5 7 14.5C10.8577 14.5 14 11.3577 14 7.5C14 3.6423 10.8577 0.5 7 0.5ZM7 1.9C10.1011 1.9 12.6 4.39891 12.6 7.5C12.6 10.6011 10.1011 13.1 7 13.1C3.89891 13.1 1.4 10.6011 1.4 7.5C1.4 4.39891 3.89891 1.9 7 1.9ZM6.3 3.3V7.78984L9.30508 10.7949L10.2949 9.80508L7.7 7.21016V3.3H6.3Z",
    fill: "#131314"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIconBlack);
export default __webpack_public_path__ + "static/media/clock-icon-black.65cbe051b182a09ff12bb2882d04da4e.svg";
export { ForwardRef as ReactComponent };